<template>
    <div class="d-flex flex-column overflow-auto">
        <filter-area
            :resources="resources"
            :locations="extractedLocations"
            :categories="categories"
            :filters="productFilters"
            :allProducts="unfilteredProducts">
        </filter-area>

        <div v-if="isLoading" class="mt-4 p-4 text-center">
            <loader></loader>
        </div>

        <div v-else>
            <product-list v-on:checkAvailability="checkAvailability" :products="filteredProducts"></product-list>
        </div>
    </div>
</template>

<script>
import FilterArea from './Search/FilterArea'
import ProductList from './Search/ProductList'
import  {mapActions, mapGetters } from 'vuex'
import Loader from '@/tools/loaders/loader1'

export default{
    data() {
        return {
            unfilteredProducts: [],
            categories: [],
            resources: [],
            productFilters: {
                categoryId: null,
                resourceId: null,
                location: null,
                title: null
            },
            isLoading: false
        }
    },
    computed:{
        ...mapGetters([
            'account'
        ]),
        extractedLocations() {
            let locations = [];
            for (let product of this.unfilteredProducts) {
                if (locations.indexOf(product.location) == -1) {
                    locations.push(product.location);
                }
            }

            return locations;
        },
        filteredProducts() {
            let productsArr = this.unfilteredProducts;

            // Filter title
            if (this.productFilters.title) {
                productsArr = productsArr.filter(product => {
                    return product.name.toLowerCase().includes(this.productFilters.title.toLowerCase());
                })
            }

            // Filter location
            if (this.productFilters.location && typeof this.productFilters.location == "string") {
                productsArr = productsArr.filter(product => {
                    return product.location == this.productFilters.location;
                })
            }

            // Filter resource
            if (this.productFilters.resourceId) {
                productsArr = productsArr.filter(product => {
                    for (let productResource of product.resources) {
                        return productResource.id == this.productFilters.resourceId;
                    }
                })
            }

            // Filter category
            if (this.productFilters.categoryId) {
                productsArr = productsArr.filter(product => {
                    for (let category of product.categoryList) {
                        if (category.id == this.productFilters.categoryId) {
                            return true;
                        }
                    }
                })
            }

            return productsArr;
        }
    },
    asyncComputed: {
        async getProducts() {
            try {
                if (this.account.supplierId) {
                    this.isLoading = true;
                    axios.get('/api/booking/Resume', {
                        params: {
                            supplierId: this.account.supplierId
                        }
                    }).then(response => {
                        this.isLoading = false;

                        if (response && response.status === 200 && response.data) {
                            this.unfilteredProducts = response.data.productList;
                            this.categories = response.data.categoryList;
                            
                            return response.data;
                        }
                    }).catch (error => {
                        this.isLoading = false;
                        this.$toasted.error(error.response.data.message);
                    })
                }
            }
            catch (error) {
                this.$toasted.error(error);
            }

        },
    },
    methods:{
        ...mapActions([
            'setReservationSelectedProduct'
        ]),
        checkAvailability(product) {            
            this.setReservationSelectedProduct(product);
            this.$router.push('/reservation/reschedule/'+product.id);
        },
    },
    components: {
        FilterArea,
        ProductList,
        Loader
    }
}
</script>

<style lang="scss">
    .scrollableArea{
        display: flex;
        height: 94vh;
        flex-direction: column;
    }
</style>



// WEBPACK FOOTER //
// SearchRebook.vue?289ed55e